/**
 * @generated SignedSource<<450f24e4ec3993d48e0269e29dee760e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type YesNoBlank = "blank" | "no" | "yes";
export type businessSmallBossMachineOwnerQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessSmallBossMachineOwnerQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly isSmallBossOrMachineOwner: YesNoBlank | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessSmallBossMachineOwnerQuery = {
  response: businessSmallBossMachineOwnerQuery$data;
  variables: businessSmallBossMachineOwnerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSmallBossOrMachineOwner",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessSmallBossMachineOwnerQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessSmallBossMachineOwnerQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3e2563e91b6be4c4745806969bec6d98",
    "id": null,
    "metadata": {},
    "name": "businessSmallBossMachineOwnerQuery",
    "operationKind": "query",
    "text": "query businessSmallBossMachineOwnerQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      isSmallBossOrMachineOwner\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ac527c5128457eb84f3ded27c08a5e46";

export default node;
